import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removefromcart } from "../Redux/Actions/cartActions";
import "../App.css";

const CartScreen = () => {
  window.scrollTo(0, 0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [animateItem, setAnimateItem] = useState(null);

  const qty = location.search ? Number(location.search.split("=")[1]) : 1;

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  // Add or update cart items on mount
  useEffect(() => {
    if (id) {
      dispatch(addToCart(id, qty));
    }
  }, [dispatch, id, qty]);

  const checkOutHandler = () => {
    navigate("/login?redirect=shipping");
  };

  const removeFromCartHandle = (id) => {
    dispatch(removefromcart(id));
  };

  const handleQuantityChange = (productId, value) => {
    setAnimateItem(productId);
    dispatch(addToCart(productId, Number(value)));

    setTimeout(() => {
      setAnimateItem(null);
    }, 1000);
  };

  // Calculate total using salePrice if exists and >0
  const total = cartItems
    .reduce((acc, item) => {
      const price =
        item.salePrice && parseFloat(item.salePrice) > 0
          ? parseFloat(item.salePrice)
          : parseFloat(item.price) || 0;
      const quantity = parseInt(item.qty) || 1;
      return acc + price * quantity;
    }, 0)
    .toFixed(2);

  const qualifiesForFreeShipping = total >= 50;

  return (
    <>
      <Header />

      <div className="container">
        {cartItems.length === 0 ? (
          <div className="empty-cart alert alert-info text-center mt-3">
            <i
              className="fas fa-shopping-cart fa-4x mb-4"
              style={{ color: "#ccc" }}
            ></i>
            <h3>Your cart is empty</h3>
            <p className="mb-4">
              Looks like you haven't added any products to your cart yet.
            </p>
            <Link className="btn btn-success mx-5 px-5 py-3" to="/">
              CONTINUE SHOPPING
            </Link>
          </div>
        ) : (
          <>
            <div className="alert alert-info text-center mt-3">
              <span className="cart-title">Your Shopping Cart</span>
              <Link className="text-success mx-2" to="/cart">
                ({cartItems.length} {cartItems.length === 1 ? "item" : "items"})
              </Link>
            </div>

            {cartItems.map((item) => {
              const price =
                item.salePrice && parseFloat(item.salePrice) > 0
                  ? parseFloat(item.salePrice)
                  : parseFloat(item.price) || 0;
              const quantity = parseInt(item.qty) || 1;
              const subtotal = price * quantity;

              return (
                <div
                  key={item.product}
                  className={`cart-iterm row ${
                    animateItem === item.product ? "qty-changed" : ""
                  }`}
                >
                  <div className="cart-image col-md-3">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <div className="cart-text col-md-5 d-flex align-items-center">
                    <Link to={`/products/${item.product}`}>
                      <h4>{item.name}</h4>
                    </Link>
                  </div>
                  <div className="cart-qty col-md-2 col-sm-5 mt-md-5 mt-3 mt-md-0 d-flex flex-column justify-content-center">
                    <h6>QUANTITY</h6>
                    <select
                      value={quantity}
                      onChange={(e) =>
                        handleQuantityChange(item.product, e.target.value)
                      }
                    >
                      {[...Array(item.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="cart-price mt-3 mt-md-0 col-md-2 align-items-sm-end align-items-start d-flex flex-column justify-content-center col-sm-7">
                    <h6>PRICE</h6>
                    <h4>${price.toFixed(2)}</h4>
                    <small className="text-muted">
                      Subtotal: ${subtotal.toFixed(2)}
                    </small>
                  </div>

                  <button
                    onClick={() => removeFromCartHandle(item.product)}
                    className="remove-button"
                    title="Remove item"
                    aria-label="Remove item"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              );
            })}

            <div className="total mt-3">
              <span className="sub">total:</span>
              <span className="total-price">${total}</span>

              {qualifiesForFreeShipping && (
                <span className="free-shipping-message">
                  Your order qualifies for FREE shipping!
                </span>
              )}
              {!qualifiesForFreeShipping && (
                <span className="shipping-message">
                  Add ${(50 - total).toFixed(2)} more to qualify for FREE shipping
                </span>
              )}
            </div>

            <hr />

            <div className="cart-buttons d-flex align-items-center row">
              <Link to="/" className="col-md-6">
                <button>
                  <i className="fas fa-arrow-left mr-2"></i> Continue Shopping
                </button>
              </Link>
              {total > 0 && (
                <div className="col-md-6 d-flex justify-content-md-end mt-3 mt-md-0">
                  <button onClick={checkOutHandler}>
                    Proceed to Checkout <i className="fas fa-arrow-right ml-2"></i>
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CartScreen;
